export default __webpack_public_path__ + "static/media/tokyo.5cab46e2.png";